import { useEffect, useState } from 'react';
import { getCompanyContext } from 'utils/setCompanyContext';

/**
 * Identidade da empresa (ou do consolidado) selecionada, estável o bastante para ser dependência
 * de efeito.
 *
 * Existe por causa de duas armadilhas do contexto atual:
 *
 * 1. **O contexto não tem campo `id`.** `setCompanyContext` grava `{ ids: [...], companies: [...] }`
 *    e `setGroupContext` grava `ids` mais os metadados do grupo — em nenhum dos dois há `id` na
 *    raiz. Depender de `companyContext?.id` produz `undefined` sempre: uma dependência constante,
 *    que nunca dispara.
 * 2. **Trocar de empresa não remonta a árvore.** `GlobalHeader` grava no localStorage e dispara
 *    `company-context-changed`; nenhuma rota muda e nenhum componente é remontado. Quem precisa
 *    recarregar dado por empresa tem de ouvir o evento.
 *
 * O evento é lido do localStorage, e não de `event.detail`, porque os emissores discordam no
 * formato: `setCompanyContext` manda `{ companyContext }` e `changeContext` manda
 * `{ context, companies }`. O localStorage é gravado antes do dispatch nos dois casos.
 */
export const chaveDaEmpresa = (contexto = getCompanyContext()) => (contexto?.ids || []).join(',');

export default function useCompanyContextKey() {
  const [chave, setChave] = useState(chaveDaEmpresa);

  useEffect(() => {
    const aoTrocar = () => setChave(chaveDaEmpresa());
    window.addEventListener('company-context-changed', aoTrocar);
    return () => window.removeEventListener('company-context-changed', aoTrocar);
  }, []);

  return chave;
}
